import React from 'react';
import YouTubeFeed from '../components/YouTubeFeed';
import SEO from '../components/SEO';
import { useTheme } from '../context/ThemeContext';

function Videos() {
  const { darkMode } = useTheme();

  return (
    <div className={`min-h-screen pt-24 sm:pt-28 pb-12 px-4 transition-colors duration-200 ${darkMode ? '' : 'bg-stone-50'}`}>
      <SEO
        title="Videoer"
        path="/videoer"
        description="Se Effekts nyeste YouTube-videoer om elbiler, rekkeviddetester, lading og bilnyheter fra norske forhold."
      />
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h1 className={`text-4xl sm:text-5xl font-bold mb-3 ${darkMode ? 'text-white' : 'text-stone-900'}`}>Videoer</h1>
          <p className={`text-lg ${darkMode ? 'text-gray-400' : 'text-stone-500'}`}>Siste videoer fra YouTube-kanalen Effekt</p>
        </div>
        <YouTubeFeed excludeShorts showAll />
      </div>
    </div>
  );
}

export default Videos;
